import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY}.${BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY}` as const;

export const ABOUT_COMPANY_HISTORY_NAMES = {
  BUSINESS_IDEA_CONCEPTION: 'businessIdeaConception',
  MOTIVATION: 'motivation',
  EVENTS: 'events',
} as const;

export const LIST_OF_KEY_EVENTS_FIELDS = {
  TITLE: 'title',
  DATE: 'date',
} as const;

export interface IHistoryAboutCompanyListOfKeyEventsForm {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: string;
  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: string;
}

export interface IHistoryAboutCompanyForm {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: string;
  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: string;
  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: IHistoryAboutCompanyListOfKeyEventsForm[];
}

export const listOfKeyEventsInitialValues: IHistoryAboutCompanyListOfKeyEventsForm = {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: '',
  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: '',
};

export const historyAboutCompanyInitialValues: IHistoryAboutCompanyForm = {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: '',
  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: '',
  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: [listOfKeyEventsInitialValues],
};
